import { PlayerEvent } from 'bitmovin-player';
export var NpoPlayerEvent;
(function (NpoPlayerEvent) {
    NpoPlayerEvent["Ready"] = "ready";
    NpoPlayerEvent["Play"] = "play";
    NpoPlayerEvent["Playing"] = "playing";
    NpoPlayerEvent["Paused"] = "paused";
    NpoPlayerEvent["Seek"] = "seek";
    NpoPlayerEvent["Seeked"] = "seeked";
    NpoPlayerEvent["TimeShift"] = "timeshift";
    NpoPlayerEvent["TimeShifted"] = "timeshifted";
    NpoPlayerEvent["VolumeChanged"] = "volumechanged";
    NpoPlayerEvent["Muted"] = "muted";
    NpoPlayerEvent["Unmuted"] = "unmuted";
    NpoPlayerEvent["PlayerResized"] = "playerresized";
    NpoPlayerEvent["PlaybackFinished"] = "playbackfinished";
    NpoPlayerEvent["Error"] = "error";
    NpoPlayerEvent["Warning"] = "warning";
    NpoPlayerEvent["StallStarted"] = "stallstarted";
    NpoPlayerEvent["StallEnded"] = "stallended";
    NpoPlayerEvent["AudioChanged"] = "audiochanged";
    NpoPlayerEvent["AudioAdded"] = "audioadded";
    NpoPlayerEvent["AudioRemoved"] = "audioremoved";
    NpoPlayerEvent["VideoQualityChanged"] = "videoqualitychanged";
    NpoPlayerEvent["AudioQualityChanged"] = "audioqualitychanged";
    NpoPlayerEvent["VideoDownloadQualityChange"] = "videodownloadqualitychange";
    NpoPlayerEvent["AudioDownloadQualityChange"] = "audiodownloadqualitychange";
    NpoPlayerEvent["VideoDownloadQualityChanged"] = "videodownloadqualitychanged";
    NpoPlayerEvent["AudioDownloadQualityChanged"] = "audiodownloadqualitychanged";
    NpoPlayerEvent["VideoPlaybackQualityChanged"] = "videoplaybackqualitychanged";
    NpoPlayerEvent["AudioPlaybackQualityChanged"] = "audioplaybackqualitychanged";
    NpoPlayerEvent["TimeChanged"] = "timechanged";
    NpoPlayerEvent["CueParsed"] = "cueparsed";
    NpoPlayerEvent["CueEnter"] = "cueenter";
    NpoPlayerEvent["CueUpdate"] = "cueupdate";
    NpoPlayerEvent["CueExit"] = "cueexit";
    NpoPlayerEvent["SegmentPlayback"] = "segmentplayback";
    NpoPlayerEvent["Metadata"] = "metadata";
    NpoPlayerEvent["MetadataParsed"] = "metadataparsed";
    NpoPlayerEvent["MetadataChanged"] = "metadatachanged";
    NpoPlayerEvent["VideoAdaptation"] = "videoadaptation";
    NpoPlayerEvent["AudioAdaptation"] = "audioadaptation";
    NpoPlayerEvent["DownloadFinished"] = "downloadfinished";
    NpoPlayerEvent["SegmentRequestFinished"] = "segmentrequestfinished";
    NpoPlayerEvent["AdManifestLoaded"] = "admanifestloaded";
    NpoPlayerEvent["AdStarted"] = "adstarted";
    NpoPlayerEvent["OverlayAdStarted"] = "overlayadstarted";
    NpoPlayerEvent["AdQuartile"] = "adquartile";
    NpoPlayerEvent["AdSkipped"] = "adskipped";
    NpoPlayerEvent["AdClicked"] = "adclicked";
    NpoPlayerEvent["AdInteraction"] = "adinteraction";
    NpoPlayerEvent["AdLinearityChanged"] = "adlinearitychanged";
    NpoPlayerEvent["AdBreakStarted"] = "adbreakstarted";
    NpoPlayerEvent["AdBreakFinished"] = "adbreakfinished";
    NpoPlayerEvent["AdFinished"] = "adfinished";
    NpoPlayerEvent["AdError"] = "aderror";
    NpoPlayerEvent["VRViewingDirectionChange"] = "vrviewingdirectionchange";
    NpoPlayerEvent["VRViewingDirectionChanged"] = "vrviewingdirectionchanged";
    NpoPlayerEvent["VRStereoChanged"] = "vrstereochanged";
    NpoPlayerEvent["CastAvailable"] = "castavailable";
    NpoPlayerEvent["CastStopped"] = "caststopped";
    NpoPlayerEvent["CastStart"] = "caststart";
    NpoPlayerEvent["CastStarted"] = "caststarted";
    NpoPlayerEvent["CastWaitingForDevice"] = "castwaitingfordevice";
    NpoPlayerEvent["SourceLoaded"] = "sourceloaded";
    NpoPlayerEvent["SourceUnloaded"] = "sourceunloaded";
    NpoPlayerEvent["PeriodSwitch"] = "periodswitch";
    NpoPlayerEvent["PeriodSwitched"] = "periodswitched";
    NpoPlayerEvent["DVRWindowExceeded"] = "dvrwindowexceeded";
    NpoPlayerEvent["SubtitleAdded"] = "subtitleadded";
    NpoPlayerEvent["SubtitleRemoved"] = "subtitleremoved";
    NpoPlayerEvent["ShowAirplayTargetPicker"] = "showairplaytargetpicker";
    NpoPlayerEvent["AirplayAvailable"] = "airplayavailable";
    NpoPlayerEvent["AirplayChanged"] = "airplaychanged";
    NpoPlayerEvent["Destroy"] = "destroy";
    NpoPlayerEvent["PlaybackSpeedChanged"] = "playbackspeedchanged";
    NpoPlayerEvent["DurationChanged"] = "durationchanged";
    NpoPlayerEvent["ViewModeChanged"] = "viewmodechanged";
    NpoPlayerEvent["ModuleReady"] = "moduleready";
    NpoPlayerEvent["SubtitleEnable"] = "subtitleenable";
    NpoPlayerEvent["SubtitleEnabled"] = "subtitleenabled";
    NpoPlayerEvent["SubtitleDisable"] = "subtitledisable";
    NpoPlayerEvent["SubtitleDisabled"] = "subtitledisabled";
    NpoPlayerEvent["VideoQualityAdded"] = "videoqualityadded";
    NpoPlayerEvent["VideoQualityRemoved"] = "videoqualityremoved";
    NpoPlayerEvent["AudioQualityAdded"] = "audioqualityadded";
    NpoPlayerEvent["AudioQualityRemoved"] = "audioqualityremoved";
    NpoPlayerEvent["TargetLatencyChanged"] = "targetlatencychanged";
    NpoPlayerEvent["LatencyModeChanged"] = "latencymodechanged";
    NpoPlayerEvent["LicenseValidated"] = "licensevalidated";
    NpoPlayerEvent["DrmLicenseAdded"] = "drmlicenseadded";
    NpoPlayerEvent["AspectRatioChanged"] = "aspectratiochanged";
})(NpoPlayerEvent || (NpoPlayerEvent = {}));
export const playerEventMap = {
    [NpoPlayerEvent.Ready]: PlayerEvent.Ready,
    [NpoPlayerEvent.Play]: PlayerEvent.Play,
    [NpoPlayerEvent.Playing]: PlayerEvent.Playing,
    [NpoPlayerEvent.Paused]: PlayerEvent.Paused,
    [NpoPlayerEvent.Seek]: PlayerEvent.Seek,
    [NpoPlayerEvent.Seeked]: PlayerEvent.Seeked,
    [NpoPlayerEvent.TimeShift]: PlayerEvent.TimeShift,
    [NpoPlayerEvent.TimeShifted]: PlayerEvent.TimeShifted,
    [NpoPlayerEvent.VolumeChanged]: PlayerEvent.VolumeChanged,
    [NpoPlayerEvent.Muted]: PlayerEvent.Muted,
    [NpoPlayerEvent.Unmuted]: PlayerEvent.Unmuted,
    [NpoPlayerEvent.PlayerResized]: PlayerEvent.PlayerResized,
    [NpoPlayerEvent.PlaybackFinished]: PlayerEvent.PlaybackFinished,
    [NpoPlayerEvent.Error]: PlayerEvent.Error,
    [NpoPlayerEvent.Warning]: PlayerEvent.Warning,
    [NpoPlayerEvent.StallStarted]: PlayerEvent.StallStarted,
    [NpoPlayerEvent.StallEnded]: PlayerEvent.StallEnded,
    [NpoPlayerEvent.AudioChanged]: PlayerEvent.AudioChanged,
    [NpoPlayerEvent.AudioAdded]: PlayerEvent.AudioAdded,
    [NpoPlayerEvent.AudioRemoved]: PlayerEvent.AudioRemoved,
    [NpoPlayerEvent.VideoQualityChanged]: PlayerEvent.VideoQualityChanged,
    [NpoPlayerEvent.AudioQualityChanged]: PlayerEvent.AudioQualityChanged,
    [NpoPlayerEvent.VideoDownloadQualityChange]: PlayerEvent.VideoDownloadQualityChange,
    [NpoPlayerEvent.AudioDownloadQualityChange]: PlayerEvent.AudioDownloadQualityChange,
    [NpoPlayerEvent.VideoDownloadQualityChanged]: PlayerEvent.VideoDownloadQualityChanged,
    [NpoPlayerEvent.AudioDownloadQualityChanged]: PlayerEvent.AudioDownloadQualityChanged,
    [NpoPlayerEvent.VideoPlaybackQualityChanged]: PlayerEvent.VideoPlaybackQualityChanged,
    [NpoPlayerEvent.AudioPlaybackQualityChanged]: PlayerEvent.AudioPlaybackQualityChanged,
    [NpoPlayerEvent.TimeChanged]: PlayerEvent.TimeChanged,
    [NpoPlayerEvent.CueParsed]: PlayerEvent.CueParsed,
    [NpoPlayerEvent.CueEnter]: PlayerEvent.CueEnter,
    [NpoPlayerEvent.CueUpdate]: PlayerEvent.CueUpdate,
    [NpoPlayerEvent.CueExit]: PlayerEvent.CueExit,
    [NpoPlayerEvent.SegmentPlayback]: PlayerEvent.SegmentPlayback,
    [NpoPlayerEvent.Metadata]: PlayerEvent.Metadata,
    [NpoPlayerEvent.MetadataParsed]: PlayerEvent.MetadataParsed,
    [NpoPlayerEvent.MetadataChanged]: PlayerEvent.MetadataChanged,
    [NpoPlayerEvent.VideoAdaptation]: PlayerEvent.VideoAdaptation,
    [NpoPlayerEvent.AudioAdaptation]: PlayerEvent.AudioAdaptation,
    [NpoPlayerEvent.DownloadFinished]: PlayerEvent.DownloadFinished,
    [NpoPlayerEvent.SegmentRequestFinished]: PlayerEvent.SegmentRequestFinished,
    [NpoPlayerEvent.AdManifestLoaded]: PlayerEvent.AdManifestLoaded,
    [NpoPlayerEvent.AdStarted]: PlayerEvent.AdStarted,
    [NpoPlayerEvent.OverlayAdStarted]: PlayerEvent.OverlayAdStarted,
    [NpoPlayerEvent.AdQuartile]: PlayerEvent.AdQuartile,
    [NpoPlayerEvent.AdSkipped]: PlayerEvent.AdSkipped,
    [NpoPlayerEvent.AdClicked]: PlayerEvent.AdClicked,
    [NpoPlayerEvent.AdInteraction]: PlayerEvent.AdInteraction,
    [NpoPlayerEvent.AdLinearityChanged]: PlayerEvent.AdLinearityChanged,
    [NpoPlayerEvent.AdBreakStarted]: PlayerEvent.AdBreakStarted,
    [NpoPlayerEvent.AdBreakFinished]: PlayerEvent.AdBreakFinished,
    [NpoPlayerEvent.AdFinished]: PlayerEvent.AdFinished,
    [NpoPlayerEvent.AdError]: PlayerEvent.AdError,
    [NpoPlayerEvent.VRViewingDirectionChange]: PlayerEvent.VRViewingDirectionChange,
    [NpoPlayerEvent.VRViewingDirectionChanged]: PlayerEvent.VRViewingDirectionChanged,
    [NpoPlayerEvent.VRStereoChanged]: PlayerEvent.VRStereoChanged,
    [NpoPlayerEvent.CastAvailable]: PlayerEvent.CastAvailable,
    [NpoPlayerEvent.CastStopped]: PlayerEvent.CastStopped,
    [NpoPlayerEvent.CastStart]: PlayerEvent.CastStart,
    [NpoPlayerEvent.CastStarted]: PlayerEvent.CastStarted,
    [NpoPlayerEvent.CastWaitingForDevice]: PlayerEvent.CastWaitingForDevice,
    [NpoPlayerEvent.SourceLoaded]: PlayerEvent.SourceLoaded,
    [NpoPlayerEvent.SourceUnloaded]: PlayerEvent.SourceUnloaded,
    [NpoPlayerEvent.PeriodSwitch]: PlayerEvent.PeriodSwitch,
    [NpoPlayerEvent.PeriodSwitched]: PlayerEvent.PeriodSwitched,
    [NpoPlayerEvent.DVRWindowExceeded]: PlayerEvent.DVRWindowExceeded,
    [NpoPlayerEvent.SubtitleAdded]: PlayerEvent.SubtitleAdded,
    [NpoPlayerEvent.SubtitleRemoved]: PlayerEvent.SubtitleRemoved,
    [NpoPlayerEvent.ShowAirplayTargetPicker]: PlayerEvent.ShowAirplayTargetPicker,
    [NpoPlayerEvent.AirplayAvailable]: PlayerEvent.AirplayAvailable,
    [NpoPlayerEvent.AirplayChanged]: PlayerEvent.AirplayChanged,
    [NpoPlayerEvent.Destroy]: PlayerEvent.Destroy,
    [NpoPlayerEvent.PlaybackSpeedChanged]: PlayerEvent.PlaybackSpeedChanged,
    [NpoPlayerEvent.DurationChanged]: PlayerEvent.DurationChanged,
    [NpoPlayerEvent.ViewModeChanged]: PlayerEvent.ViewModeChanged,
    [NpoPlayerEvent.ModuleReady]: PlayerEvent.ModuleReady,
    [NpoPlayerEvent.SubtitleEnable]: PlayerEvent.SubtitleEnable,
    [NpoPlayerEvent.SubtitleEnabled]: PlayerEvent.SubtitleEnabled,
    [NpoPlayerEvent.SubtitleDisable]: PlayerEvent.SubtitleDisable,
    [NpoPlayerEvent.SubtitleDisabled]: PlayerEvent.SubtitleDisabled,
    [NpoPlayerEvent.VideoQualityAdded]: PlayerEvent.VideoQualityAdded,
    [NpoPlayerEvent.VideoQualityRemoved]: PlayerEvent.VideoQualityRemoved,
    [NpoPlayerEvent.AudioQualityAdded]: PlayerEvent.AudioQualityAdded,
    [NpoPlayerEvent.AudioQualityRemoved]: PlayerEvent.AudioQualityRemoved,
    [NpoPlayerEvent.TargetLatencyChanged]: PlayerEvent.TargetLatencyChanged,
    [NpoPlayerEvent.LatencyModeChanged]: PlayerEvent.LatencyModeChanged,
    [NpoPlayerEvent.LicenseValidated]: PlayerEvent.LicenseValidated,
    [NpoPlayerEvent.DrmLicenseAdded]: PlayerEvent.DrmLicenseAdded,
    [NpoPlayerEvent.AspectRatioChanged]: PlayerEvent.AspectRatioChanged
};
